import api from '@motionelements/core/src/api/base-api-v2';

const mainUrl = '/v2/artist/programs';

export default {
  listPrograms(params = {}) {
    return api.get(`${mainUrl}`, {
      params: {
        ...params,
        ...api.getLocaleParams(),
      },
    });
  },
  getProgram(programId) {
    return api.get(`${mainUrl}/${programId}`, {
      params: {
        ...api.getLocaleParams(),
      },
    });
  },
  optIn({ subProgramId, data }) {
    return api.request('post', `${mainUrl}/${subProgramId}`, {
      data,
      params: api.getLocaleParams(),
    });
  },
  optOut(subProgramId) {
    return api.request('delete', `${mainUrl}/${subProgramId}`, {
      params: api.getLocaleParams(),
    });
  },
  updateSubProgram({ subProgramId, data }) {
    return api.request('patch', `${mainUrl}/${subProgramId}`, {
      data,
      params: api.getLocaleParams(),
    });
  },
};
